<template>
  <div id="app">
    <Home msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import Home from './home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
*{
	margin: 0;
	padding: 0;
}
@font-face {
  font-family: 'webfont';
  font-display: swap;
  src: url('//at.alicdn.com/t/webfont_siqo1oil6m.eot'); /* IE9*/
  src: url('//at.alicdn.com/t/webfont_siqo1oil6m.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('//at.alicdn.com/t/webfont_siqo1oil6m.woff2') format('woff2'),
  url('//at.alicdn.com/t/webfont_siqo1oil6m.woff') format('woff'), /* chrome、firefox */
  url('//at.alicdn.com/t/webfont_siqo1oil6m.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
  url('//at.alicdn.com/t/webfont_siqo1oil6m.svg#阿里汉仪智能黑体') format('svg'); /* iOS 4.1- */
}

</style>
